import { Task } from './task.model'
import { WpPerson } from './wp-person.model';
import { AssessmentSummary } from './AssessmentSummary.model';

export class Appointment {
constructor(
      public id?: number,
      public appointmentType?: string,
      public appointmentDt?: any,
      public appointmentTime?: any,
      public appointmentStatusCd?: any,
      public appointmentMethodCd?: any,
      public appointmentLocation?: any,
      public createdBy?: any,
      public referralId?: number,
      public wpTask?: Task,
      public wpPerson?: WpPerson,
      public recordVersion?: number,
      public assessment?:AssessmentSummary,
      public ncNumber?: number,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/appointment.model.ts